
      // Import the functions you need from the SDKs you need
      import { initializeApp } from "https://www.gstatic.com/firebasejs/12.3.0/firebase-app.js";
      import { getAnalytics } from "https://www.gstatic.com/firebasejs/12.3.0/firebase-analytics.js";
      // TODO: Add SDKs for Firebase products that you want to use
      // https://firebase.google.com/docs/web/setup#available-libraries

      // Your web app's Firebase configuration
      // For Firebase JS SDK v7.20.0 and later, measurementId is optional
      const firebaseConfig = {
        apiKey: "AIzaSyALaQ2qW0W9vbRykiY3mz6dr4YVzSZ-9hU",
        authDomain: "glurrter.firebaseapp.com",
        projectId: "glurrter",
        storageBucket: "glurrter.firebasestorage.app",
        messagingSenderId: "61385641505",
        appId: "1:61385641505:web:c49ec77df931861a2fdd60",
        measurementId: "G-KPN6R2V3MC"
      };

      // Initialize Firebase
      const app = initializeApp(firebaseConfig);
      const analytics = getAnalytics(app);
    